import { FAQ } from '@teko/types/ecommerce';
import { useTenantConfig } from 'contexts';
import { Shape, Flex, SubTitle, Container, styled } from '@teko/ds-desktop';
import { t } from 'i18n';
import { useRef, useState } from 'react';
import { RightOutlined, DownOutlined, QaOutlined } from '@teko/ds-icon';
import Head from 'next/head';

export const FAQSection = ({
  faq,
  style,
}: {
  faq: Array<FAQ>;
  style?: React.CSSProperties;
}) => {
  const { isMobile } = useTenantConfig();
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faq.map(({ question, answer }) => ({
                '@type': 'Question',
                name: question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: answer,
                },
              })),
            }),
          }}
        />
      </Head>
      <Container
        style={style ? style : isMobile ? { padding: '0px' } : {}}
        marginBottom="s8"
      >
        <Shape borderRadius="xl" backgroundColor="white">
          <Shape padding={['s12', 's16']}>
            <StyledTitle>{t('Câu hỏi thường gặp')}</StyledTitle>
          </Shape>
          {faq.map((item, index) => (
            <FAQItem key={index} item={item} />
          ))}
        </Shape>
      </Container>
    </>
  );
};

const FAQItem = ({ item }: { item: FAQ }) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [isShowingAnswer, setShowingAnswer] = useState(false);
  const answers = item.answer?.split('\n');

  return (
    <Shape>
      <Flex
        justify="space-between"
        align="center"
        padding={['s12', 's16']}
        backgroundColor="#00000005"
        borderBottom="1px solid #00000026"
        onClick={() => {
          setShowingAnswer((previous) => !previous);
        }}
        style={{ cursor: 'pointer' }}
      >
        <Shape>
          <SubTitle level={3}>
            <StyledQaOutlined size={16} />
            {item.question}
          </SubTitle>
        </Shape>
        {isShowingAnswer ? <DownOutlined /> : <RightOutlined />}
      </Flex>
      <Shape
        backgroundColor="white"
        style={{
          overflow: 'hidden',
          transition: 'height 0.3s ease',
          height: isShowingAnswer ? contentRef.current?.clientHeight : 0,
        }}
      >
        <Shape ref={contentRef} padding="s16">
          {answers?.map((line, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: line }} />
          ))}
        </Shape>
      </Shape>
    </Shape>
  );
};

const StyledQaOutlined = styled(QaOutlined)`
  margin-right: 8px;
`;

const StyledTitle = styled.h3`
  line-height: 32px;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0;
`;
